import React from 'react'

import TextBlock from "./components/TextBlock/textBlock"
import PromotionalOffer from "./components/PromotionalOffer/promotionalOffer"
import DkLiveBlock from "./components/DkLiveBlock/dkLiveBlock"
import QuoteBlock from "./components/QuoteBlock/quoteBlock"
import ProductImage from "./components/ProductImage/productImage"
import Hero from "./components/Hero/hero"
import RichText from "./components/RichText/richText"
import Locations from "./components/Locations/location"
import ProductTypeBlock from "./components/ProductTypeBlock/productTypeBlock"
import Leadership from "./components/Leadership/leadership"
import StaggeredImageText from "./components/StaggeredImageText/staggeredImageText"
import ThreeColumnCards from "./components/ThreeColumnCards/threeColumnCards"
import ContestSchedule from "./components/ContestSchedule/ContestScheduleWrapper"
import DynamicTable from "./components/Table/table"
import DynamicTableV2 from "./components/Table/tableV2"
import FAQ from "./components/FAQ/faq"
import AdSpace from "./components/AdSpace/adSpace"
import Resources from "./components/Resources/resources"
import TwoColumnRichContentBlock from "./components/TwoColumnRichContentBlock/twoColumnRichContentBlock"
import NavigationMenuBlock from "./components/NavigationMenuBlock/navigationMenuBlock"
import TwoColumnContent from "./components/TwoColumnContent/twoColumnContent"

export const parseContentstackComponent = (props) => {
  switch (props.__typename) {
    case "Contentstack_hero":
      return <Hero {...props} />
    case "Contentstack_dk_live_component":
      return <DkLiveBlock {...props} />
    case "Contentstack_quote_component":
      return <QuoteBlock {...props} />
    case "Contentstack_generic_content_component":
      return <TextBlock {...props} />
    case "Contentstack_product_image_component":
      return <ProductImage {...props} />
    case "Contentstack_rich_text_component":
      return <RichText {...props} />
    case "Contentstack_staggered_image_text_component":
      return <StaggeredImageText {...props} />
    case "Contentstack_leadership":
      return <Leadership {...props} />
    case "Contentstack_locations":
      return <Locations {...props} />
    case "Contentstack_promotional_offer_component":
      return <PromotionalOffer {...props} />
    case "Contentstack_game_type_component":
      return <ProductTypeBlock {...props} />
    case "Contentstack_table":
      return <DynamicTable {...props} />
    case "Contentstack_faq":
      return <FAQ {...props} />
    case "Contentstack_ad_space":
      return <AdSpace {...props} />
    case "Contentstack_tablev2":
      return <DynamicTableV2 {...props} />
    case "Contentstack_resources":
      return <Resources {...props} />
    case "Contentstack_3xcolumn_cards_component":
      return <ThreeColumnCards {...props} />
    case "Contentstack_navigation_menu_block":
      return <NavigationMenuBlock {...props}/>
    case "Contentstack_two_column_rich_content_block":
      return <TwoColumnRichContentBlock {...props} />
    case "Contentstack_contest_schedule":
      return <ContestSchedule {...props}/>
    case "Contentstack_two_column_content":
      return <TwoColumnContent {...props} />
    default:
      return null;
  }
}